import React from 'react';
import classNames from 'classnames';

import './Button.scss';
import { Colors } from '../../Tenants';

interface ButtonProps {
  block?: any;
  color?: any;
  disabled?: any;
  outlined?: any;
  icon?: any;
  label?: any;
  onClick?: any;
  size?: any;
  outline?: any;
  weight?: any;
  children?: any;
  style?: any;
  [key: string]: any; // For rest props
}

const Button: React.FC<ButtonProps> = ({
  block,
  color,
  disabled,
  outlined,
  icon,
  label,
  onClick,
  size,
  outline,
  weight,
  children,
  style,
  ...rest
}) => (
  <button
    disabled={disabled}
    onClick={onClick}
    style={{ backgroundColor: Colors.buttonColor, ...style }}
    className={classNames('button', {
      [`button--${color}`]: color,
      [`button--${size}`]: size,
      [`button--${weight}`]: weight,
      [`button--outline-${outline}`]: outline,
      'button--disabled': disabled,
      'button--outlined': outlined,
      'button--block': block,
    })}
    {...rest}
  >
    <div className="button__body">
      {icon && <div className="button__icon">{icon}</div>}
      {label && <div className="button__label cut-text">{label}</div>}
      {children && <div className="button__label cut-text">{children}</div>}
    </div>
  </button>
);

export default Button;
